export interface UserProps {
  firstName: string;
  lastName: string;
  avatarUrl?: string;
  email?: string;
}

export class User {
  public readonly firstName: string;
  public readonly lastName: string;
  public readonly email?: string;
  private readonly avatarUrl?: string;

  constructor({ firstName, lastName, avatarUrl, email }: UserProps) {
    this.firstName = firstName;
    this.lastName = lastName;
    this.avatarUrl = avatarUrl;
    this.email = email;
  }

  public displayFullName(): string {
    return `${this.firstName ?? ''} ${this.lastName ?? ''}`;
  }

  public displayFullNameOrUndefined(): string | undefined {
    return this.firstName && this.firstName !== '' &&
            this.lastName && this.lastName !== ''
            ? this.displayFullName()
            : undefined;
  }

  public get initials(): string {
    return `${this.firstName?.[0] ?? ''}${this.lastName?.[0] ?? ''}`;
  }

  public get avatar(): string | undefined {
    return this.avatarUrl;
  }
}